<div class="content-wrapper-inner">
  <div class="page-content">
    <div>
      <app-appscripts-cli-filter (onSubmit)="onSubmitSearchForm($event)"></app-appscripts-cli-filter>
    </div>
    <div class="pos-relative">
      <app-appscripts-cli-table></app-appscripts-cli-table>
    </div>
  </div>
</div>
